import {
  Stack,
  Container,
  Box,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  UnorderedList,
  ListItem,
  Text,
  Link,
} from "@chakra-ui/react";
import CombinedHeading from "../../common/CombinedHeading";
import { linksConfig } from "../../../utils/CommonLinks";

const FaqSection = () => {
  return (
    <>
      <Stack as="div" bg={"#111"}>
        <Container
          maxW={"7xl"}
          pt={{ base: 0, md: 4 }}
          pb={{ base: 4, md: 4 }}
        >
          <Box as="div" color="brand.white" fontSize={{ base: "xs", md: "md" }}>
            <CombinedHeading
              topHeading="FAQs"
              mainHeading="Frequently Asked Questions"
              subHeading="Common questions about our Solana gRPC infrastructure"
              isCenter={true}
            />
            <Box as="div" pt={{ base: 12, lg: 16 }} pb={{ base: 4, lg: 12 }}>
              <Accordion defaultIndex={[0]} allowMultiple>

              

                <AccordionItem borderColor={"brand.yellow"}>
                  <h2>
                    <AccordionButton>
                      <Box
                        as="span"
                        flex="1"
                        textAlign="left"
                        fontWeight={600}
                        pt={2}
                      >
                        Do you have code examples on how to connect to your GRPC?
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                  </h2>
                  <AccordionPanel pb={4} color="brand.grey">
                  Yes, Shyft provides code examples in Typescript and Rust, on how to properly
                   connect to gRPC and handle reconnections. Please go through our 
                   <Link
                      as={"a"}
                      href={linksConfig.DISCORD_LINK}
                      target="_blank"
                      color={"brand.yellow"}
                      _hover={{ color: "brand.red" }}
                    > Docs</Link> and 
                   <Link
                      as={"a"}
                      href={linksConfig.GITHUB_LINK}
                      target="_blank"
                      color={"brand.yellow"}
                      _hover={{ color: "brand.red" }}
                    > Github </Link> 
                   for detailed info.
                  </AccordionPanel>
                </AccordionItem>

                <AccordionItem borderColor={"brand.yellow"}>
                  <h2>
                    <AccordionButton>
                      <Box
                        as="span"
                        flex="1"
                        textAlign="left"
                        fontWeight={600}
                        pt={2}
                      >
                        Do you have any examples on how to parse gRPC data?
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                  </h2>
                  <AccordionPanel pb={4} color="brand.grey">
                  Shyft develops and manages the most exhaustive gRPC development resource our there on Solana. We cover specific use 
                  cases targeting top dexes like Raydium, Pumpfun, Meteora, orca etc with code examples in multiple languages that 
                  helps you get up and running quickly. You can check out our <Link
                      as={"a"}
                      href={"https://github.com/Shyft-to/solana-defi/"}
                      target="_blank"
                      color={"brand.yellow"}
                      _hover={{ color: "brand.red" }}
                    >Github repo</Link>. 
                  Don’t forget to follow us give a star. We welcome PRs from community.
                  </AccordionPanel>
                </AccordionItem>

                <AccordionItem borderColor={"brand.yellow"}>
                  <h2>
                    <AccordionButton>
                      <Box
                        as="span"
                        flex="1"
                        textAlign="left"
                        fontWeight={600}
                        pt={2}
                      >
                        How do I handle gRPC disconnections?
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                  </h2>
                  <AccordionPanel pb={4} color="brand.grey">
                  There are situations when a gRPC stream can be disconnected. For example, if the node you are connect 
                  to starts lagging lagging, we trigger a forceful disconnect so that you reconnect to our backup nodes. 
                  We also need to upgrade nodes to the latest Solana versions, at that time your stream can break. You 
                  can follow our reconnect examples in Typescript and Rust {" "}
                  <Link
                      as={"a"}
                      href={"https://github.com/Shyft-to/solana-defi/tree/main/general-grpc-examples"}
                      target="_blank"
                      color={"brand.yellow"}
                      _hover={{ color: "brand.red" }}
                    >
                       here.
                    </Link>
                    
                    
                  </AccordionPanel>
                </AccordionItem>

                <AccordionItem borderColor={"brand.yellow"}>
                  <h2>
                    <AccordionButton>
                      <Box
                        as="span"
                        flex="1"
                        textAlign="left"
                        fontWeight={600}
                        pt={2}
                      >
                        How do I handle missed slots during disconnection?
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                  </h2>
                  <AccordionPanel pb={4} color="brand.grey">
                  Shyft gRPC nodes enable you to stream data from historical slots also. For example, if your stream broke at slot X, you can reconnect from Slot X by mentioning `from_slot` param in your subscribe request. This way you wont miss any data. You can check out examples {" "} 
                  <Link
                      as={"a"}
                      href={"https://github.com/Shyft-to/solana-defi/tree/main/general-grpc-examples"}
                      target="_blank"
                      color={"brand.yellow"}
                      _hover={{ color: "brand.red" }}
                    >
                      here.
                    </Link>
                    
                    
                  </AccordionPanel>
                </AccordionItem>

                <AccordionItem borderColor={"brand.yellow"}>
                  <h2>
                    <AccordionButton>
                      <Box
                        as="span"
                        flex="1"
                        textAlign="left"
                        fontWeight={600}
                        pt={2}
                      >
                        Why is lag building up over time with gRPC?
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                  </h2>
                  <AccordionPanel pb={4} color="brand.grey">
                    <Box>
                      If you notice that over time lag starts to build up, then
                      there are two possible reasons.
                      <UnorderedList>
                        <ListItem>
                          Your server is far away from the gRPC region you are
                          connecting to. For example, if you are connecting to {" "}
                          <Text as="span" color={"brand.yellow"}>
                            https://grpc.ams.shyft.to
                          </Text>
                          , your server should also be in the same region i.e
                          Ams. We have seen cases where lag starts to build up
                          over time if the server is far away. Its acceptable if
                          ping {`< 10ms`}, although some users would want it to
                          be less than 1ms.
                        </ListItem>
                        <ListItem>
                          Another reason is that typescript sometimes is not
                          able to keep up with gRPC speed. We suggest using{" "}
                          <Text as="span" color={"brand.yellow"}>
                            Rust gRPC{" "}
                          </Text>
                          client for fastest processing. We have some sample
                          codes in our{" "}
                          <Link
                            as={"a"}
                            href="https://github.com/Shyft-to/solana-defi"
                            target="_blank"
                            color={"brand.yellow"}
                            _hover={{ color: "brand.red" }}
                          >
                            Github repo
                          </Link>{" "}
                          and{" "}
                          <Link
                            as={"a"}
                            href="https://github.com/Shyft-to/solana-defi"
                            target="_blank"
                            color={"brand.yellow"}
                            _hover={{ color: "brand.red" }}
                          >
                            Replit
                          </Link>
                          .
                        </ListItem>
                        <ListItem>Don't use VPNs.</ListItem>
                        <ListItem>
                          At anytime you can verify the current slot of all our
                          regions here.
                        </ListItem>
                      </UnorderedList>
                    </Box>
                  </AccordionPanel>
                </AccordionItem>

                <AccordionItem borderColor={"brand.yellow"}>
                  <h2>
                    <AccordionButton>
                      <Box
                        as="span"
                        flex="1"
                        textAlign="left"
                        fontWeight={600}
                        pt={2}
                      >
                        Is it mandatory to whitelist my IP address. Can i
                        connect without whitelisting my IP address?
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                  </h2>
                  <AccordionPanel pb={4} color="brand.grey">
                    No, it is <b>not</b> mandatory to whitelist your IP for gRPC
                    connection. You can use your access token(x-token) to
                    connect via the gRPC client. IP whitelisting is only for
                    cases where you do not have an option to whitelist your
                    token. You can findout more about whitelisting your IP
                    <Link
                      as={"a"}
                      href={
                        "https://docs.shyft.to/solana-yellowstone-grpc/grpc-docs#authentication"
                      }
                      target="_blank"
                      color={"brand.yellow"}
                      _hover={{ color: "brand.red" }}
                    >
                      {" "}
                      here
                    </Link>
                    .
                  </AccordionPanel>
                </AccordionItem>

                <AccordionItem borderColor={"brand.yellow"}>
                  <h2>
                    <AccordionButton>
                      <Box
                        as="span"
                        flex="1"
                        textAlign="left"
                        fontWeight={600}
                        pt={2}
                      >
                        Why am I getting Maximum IP limit reached for token
                        error?
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                  </h2>
                  <AccordionPanel pb={4} color="brand.grey">
                    <UnorderedList>
                      <ListItem>
                        Base $199/mo subscription gives you access to connect
                        from one IP. If you connect from multiple IPs, you will
                        get this error.
                      </ListItem>
                      <ListItem>
                        You can also get this when you change your server and
                        the connection was not gracefully shutdown. In those
                        cases you can clear your previous connection through
                        this link
                        https://grpc.ams.shyft.to/clear-connections?xtoken=your-token
                        Add your token in the end, grpc region doesnt matter.
                      </ListItem>
                    </UnorderedList>
                  </AccordionPanel>
                </AccordionItem>

                <AccordionItem borderColor={"brand.yellow"}>
                  <h2>
                    <AccordionButton>
                      <Box
                        as="span"
                        flex="1"
                        textAlign="left"
                        fontWeight={600}
                        pt={2}
                      >
                        How do i check if any gRPC region is lagging or not?
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                  </h2>
                  <AccordionPanel pb={4} color="brand.grey">
                    We have a public dashboard where you can see lag of all gRPC
                    regions in our network. We compare it against Solana
                    mainnet-beta. You can access it{" "}
                    <Link
                      as={"a"}
                      href="http://metrics-pool.shyft.to:3000/public-dashboards/23f6575360d9490e8fff3a82ae4f5a08"
                      target="_blank"
                      color={"brand.yellow"}
                      _hover={{ color: "brand.red" }}
                    >
                      here
                    </Link>
                    .
                  </AccordionPanel>
                </AccordionItem>

                <AccordionItem borderColor={"brand.yellow"}>
                  <h2>
                    <AccordionButton>
                      <Box
                        as="span"
                        flex="1"
                        textAlign="left"
                        fontWeight={600}
                        pt={2}
                      >
                        How can I increase my total number of allowed IPs?
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                  </h2>
                  <AccordionPanel pb={4} color="brand.grey">
                    If you are getting Maximum IP limit reached for token and
                    want to increase your limit for that reason, we would
                    recommend you check the second FAQ in this section.
                    Additional IPs are priced at{" "}
                    <Text as="span" color={"brand.yellow"}>
                      $199/ip/mo
                    </Text>
                    , but discounts are available on 2 or more IPs. Please reach
                    out to us on
                    <Text as="span" color={"brand.yellow"}>
                      {" "}
                      dashboard support
                    </Text>{" "}
                    or{" "}
                    <Link
                      as={"a"}
                      href={linksConfig.DISCORD_LINK}
                      target="_blank"
                      color={"brand.yellow"}
                      _hover={{ color: "brand.red" }}
                    >
                      Discord
                    </Link>
                    , to unlock more IPs.
                  </AccordionPanel>
                </AccordionItem>

                

                <AccordionItem borderColor={"brand.yellow"}>
                  <h2>
                    <AccordionButton>
                      <Box
                        as="span"
                        flex="1"
                        textAlign="left"
                        fontWeight={600}
                        pt={2}
                      >
                        Where do I reach out in case of any questions?
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                  </h2>
                  <AccordionPanel pb={4} color="brand.grey">
                    We are always happy to help with your queries. You can reach out to Shyft team from your 
                    dashboard Support chat or on Shyft Discord.
                  </AccordionPanel>
                </AccordionItem>

              </Accordion>
            </Box>
          </Box>
        </Container>
      </Stack>
    </>
  );
};

export default FaqSection;
